import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  Box,
  Button,
  DialogActions,
  TextField,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import DefaultModal from '../../components/Modals/DefaultModal';
import { Project } from '../../models/project';
import { projectService } from '../../services/projectService';

interface Props {
  modalData: { open: boolean; project?: Project };
  closeModal: () => void;
}

const AcceptModal = (props: Props): JSX.Element => {
  const { modalData, closeModal } = props;
  const [message, setMessage] = useState<string>('');

  const sendMessage = () => {
    if (modalData.project?.id) {
      projectService
        .acceptProjectMessage({
          projectId: modalData.project?.id,
          message
        })
        .then(() => {
          setMessage('');
          closeModal();
        });
    }
  };

  return (
    <DefaultModal open={modalData.open} handleClose={sendMessage}>
      <Box
        sx={{ px: 6 }}
        alignItems="center"
        display="flex"
        flexDirection="column"
      >
        <CheckCircleIcon color="success" fontSize="large" />
        <Typography
          variant="h4"
          textAlign="center"
          color="grey.700"
          mb={2}
          mt={4}
        >
          Project Accepted
        </Typography>
      </Box>

      <Box
        mt={4}
        mb={4}
        sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}
      >
        <Typography
          sx={{
            maxWidth: '80%'
          }}
          variant="body1"
          textAlign="center"
          color="grey.700"
        >
          Now that your project is accepted, you can send an optional message to
          your manager below.
        </Typography>
      </Box>
      <TextField
        multiline
        sx={{ padding: '0px 70px' }}
        onChange={(event) => setMessage(event.target.value)}
      />
      <DialogActions sx={{ justifyContent: 'center', py: 3 }}>
        <Button variant="outlined" onClick={sendMessage}>
          Close
        </Button>
        <Button onClick={sendMessage}>Submit</Button>
      </DialogActions>
    </DefaultModal>
  );
};

export default AcceptModal;
